export const DELETE_SELECTION_GIFT_MUTATION = `
mutation CartMutation{
  deleteGiftSelection {
      data {
        products {
          productId
          itemId
        },
        serviceItems {
          giftPackagings {
              productId
              productCode
              itemId
              count
              vat
              priceWithVat
              priceSumWithVat
          }
        },
        pricesSummary {
          vat
          priceItemSummary
          pricePayment
          priceDelivery
          priceProductsSummary
          discountWithoutDelivery
        }
      }
      messages
    }
}`;
